import { render } from "./product-gallery-bottom-thumbs.vue?vue&type=template&id=7709bf4a"
import script from "./product-gallery-bottom-thumbs.vue?vue&type=script&lang=js"
export * from "./product-gallery-bottom-thumbs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__